import React, { useContext } from 'react';
import Card from '../Card';
import { ColumnContainer, ColumnTitle } from './styles';

function Column({ column, onCardClick, onDropCard, onTitleClick }){
	const handleDrop = (e) => {
		e.preventDefault();
		onDropCard(e, column.id);
	};

	const handleDragOver = (e) => {
		e.preventDefault();
	};

	const handleTitleClick = (e, column) => {
		e.preventDefault();

		if ( onTitleClick ) {
			onTitleClick(e, column)
		}
	}

	return (
	<ColumnContainer onDrop={handleDrop} onDragOver={handleDragOver}>
		<ColumnTitle onClick={(e) => {handleTitleClick(e, column)}}>{column.title}</ColumnTitle>
		{column.cards.map(card => (
			<Card
				key={card.Id}
				card={card}
				onClick={() => onCardClick(card)}
				sourceColumnId={column.id}
			/>
		))}
	</ColumnContainer>
	);
};

export default Column;
